import React from 'react';
import {StyleSheet, View, Text} from 'react-native';
import {globalFontStyle} from '../../../assets';
import Colors from '../../../assets/Color/Colors';
import FastImage from '../../../common/FastImage';
import {backArrow, right_arrow} from '../../../utils/images';
import {isMobile} from '../../../utils/commonMethods';
import moment from 'moment';
import {
  globalConfigurableData,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {globalImport} from '../../../common/globalImports';

const HashTagCard = ({hashTagData}) => {
  let matchStatus = null;
  let parsedDate = moment
    .utc(hashTagData?.match_start)
    .local()
    .format('MMMM DD, YYYY');
  let dateNow = moment.utc(Date.now()).local().format('MMMM DD, YYYY');
  if (Date.parse(hashTagData?.match_start) < Date.now()) {
    matchStatus = 'live';
  } else if (dateNow === parsedDate) {
    matchStatus = 'today';
  } else {
    matchStatus = 'someday';
  }

  return (
    <View>
      <View
        style={[
          styles.cardContainer,
            isMobile() && {marginHorizontal: -16},
          GlobalScreens.Home?.mCardBorder
            ? {borderColor: GlobalScreens.Home?.mCardBorder}
            : {},
        ]}>
        {hashTagData?.match_start ? (
          <View style={{flexDirection: 'row', marginVertical: -8, flex: 1}}>
            <View
              style={[
                styles.startCard,
                {
                  backgroundColor:
                    matchStatus === 'someday'
                      ? Colors.green
                      : matchStatus === 'today'
                      ? Colors.orange
                      : Colors.red,
                },
              ]}
            />
            <View style={{marginVertical: 8, flex: 1}}>
              <View
                style={{
                  flexDirection: 'row',
                  flex: 1,
                  alignItems: 'center',
                }}>
                <Text
                  style={[
                    globalFontStyle.appFontHeading,
                    {color: GlobalScreens?.Home?.hashTagTitleColor},
                  ]}
                  numberOfLines={1}>
                  {hashTagData?.hashtags + '   '}
                </Text>
                <Text
                  numberOfLines={1}
                  style={[
                    globalFontStyle.appFontBody,
                    globalImport?.isWeb
                      ? {marginLeft: 5, flex: 'none'}
                      : {marginLeft: 5},
                    matchStatus === 'live'
                      ? styles.liveText
                      : {
                          color: globalConfigurableData.secondaryTextColor1,
                        },
                  ]}>
                  {matchStatus === 'someday'
                    ? 'On ' +
                      moment
                        .utc(hashTagData?.match_start)
                        .local()
                        .format('DD MMM')
                    : matchStatus === 'today'
                    ? 'Starts at ' +
                      moment
                        .utc(hashTagData?.match_start)
                        .local()
                        .format('hh:mm a')
                    : 'Live'}
                </Text>
              </View>
              <View>
                <Text
                  style={[
                    globalFontStyle.appFontBody,
                    matchStatus === 'live'
                      ? {color: Colors.red}
                      : {
                          color:
                            matchStatus === 'today'
                              ? Colors.orange
                              : Colors.green,
                          marginTop: 5,
                        },
                  ]}>
                  {hashTagData?.tournament_name ||
                    `(+${hashTagData?.events}` +
                      (hashTagData?.events === 1 ? ' Market)' : ' Markets)')}
                </Text>
              </View>
            </View>
          </View>
        ) : (
          <View>
            <Text
              style={[
                globalFontStyle.appFontHeading,
                {
                  color: GlobalScreens?.Home?.hashTagTitleColor,
                  flexWrap: 'wrap',
                  flex: 1,
                },
              ]}
              numberOfLines={2}>
              {hashTagData?.hashtags}
            </Text>
            <Text
              style={[
                globalFontStyle.appFontBody,
                {color: globalConfigurableData.secondaryTextColor1},
              ]}>
              {hashTagData?.tournament_name ||
                `+${hashTagData?.events}` +
                  (hashTagData?.events === 1 ? ' Market)' : ' Markets')}
            </Text>
          </View>
        )}
        <View style={{justifyContent: 'center'}}>
          <FastImage
            style={styles.backBtnStyle}
            source={globalConfigurableData?.right_arrow()}
          />
        </View>
      </View>
    </View>
  );
};

export default HashTagCard;

const styles = StyleSheet.create({
  cardImg: {
    width: 60,
    height: 60,
    marginRight: 16,
    borderRadius: 8,
    overflow: 'hidden',
  },
  volStyle: {
    width: 13,
    height: 13,
    marginRight: 6,
  },
  cardContainer: {
    borderColor: globalConfigurableData.borderColor,
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderRadius: 8,
    borderWidth: 0.75,
    marginTop: isMobile() ? 15 : 20,
    backgroundColor: Colors.chipBackground,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  startCard: {
    height: '100%',
    width: 5,
    marginLeft: -15,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    marginRight: 10,
  },
  liveText: {
    color: Colors.bgWhite,
    //marginTop: 5,
    borderRadius: 100,
    width: 45,
    paddingHorizontal: 5,
    textAlign: 'center',
    paddingVertical: 1,
    backgroundColor: Colors.red,
  },
  backBtnStyle: {
    width: 40,
    height: 40,
    transform: [{rotate: '360deg'}],
  },
});
